import * as React from 'react'
import { Card, Subhead, Text } from 'rebass'
import styled from 'styled-components'
import Link from 'gatsby-link'
import { DateLabel } from './Styled'

export interface BlogPost {
  id: string
  excerpt: string
  frontmatter: {
    title: string
    date: string
  }
  wordCount: {
    sentences: number
  }
  fields: {
    slug: string
  }
}

interface Props {
  post: BlogPost
}

const PostItemWrapper = Card.extend`
  max-width: 35rem;
  margin: 2rem;
  padding: 1rem;
  color: black;
  transition: box-shadow 0.3s ease-in-out;
`
class BlogItem extends React.PureComponent<Props, {}> {
  render() {
    const { post } = this.props
    return post ? (
      <PostItemWrapper>
        {post.frontmatter && (
          <Link style={{ color: 'black' }} to={post.fields.slug}>
            <Subhead>{post.frontmatter.title}</Subhead>
          </Link>
        )}
        {post.frontmatter && <DateLabel>{post.frontmatter.date}</DateLabel>}
        <Text p={2}>{post.excerpt}</Text>
      </PostItemWrapper>
    ) : null
  }
}

export default BlogItem



// WEBPACK FOOTER //
// ./src/components/BlogItem.tsx